var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{staticClass:"grab-hydraulic-fluid-pressure-component"},[(_vm.measurementsData)?_c('apexchart',{attrs:{"type":"line","height":"400","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }